import { Injectable } from "@angular/core";
import { gql, Apollo, Query } from "apollo-angular";
import { ChallengeType } from "../../graphql";
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };


export type GetChallengeByIdQuery = { getChallenge: { id: string, language: string, type: ChallengeType} };
export type GetChallengeByIdQueryVariables = Exact<{
  id: string;
  language: string;
}>;

export const GetChallengeByIdDocument = gql`
query getChallenge($id: String!, $language: String!) {
  getChallenge(id: $id, language: $language) {
    id
    type
    language
  }
}`;


@Injectable({
  providedIn: 'root'
})
export class GetChallengeByIdGQL extends Query<GetChallengeByIdQuery, GetChallengeByIdQueryVariables> {
  document = GetChallengeByIdDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}